var map = {
	"./App": 86351,
	"./App.vue": 86351,
	"./assets/about/Group.png": 31009,
	"./assets/about/Group2.png": 3143,
	"./assets/about/Group3.png": 34302,
	"./assets/about/food.png": 67038,
	"./assets/about/food2.jpeg": 67239,
	"./assets/about/pay.png": 46230,
	"./assets/about/people.png": 61255,
	"./assets/about/people2.png": 67541,
	"./assets/about/title.png": 17494,
	"./assets/about/title2.png": 3734,
	"./assets/about/title3.png": 57535,
	"./assets/about/title4.png": 29504,
	"./assets/baozang.gif": 18417,
	"./assets/browse/off-icon.png": 34284,
	"./assets/browse/search_icon.png": 18811,
	"./assets/browse/shop_car_empty.png": 51062,
	"./assets/contact/add.png": 87954,
	"./assets/contact/email.png": 25003,
	"./assets/contact/icon1.png": 41931,
	"./assets/contact/icon2.png": 28112,
	"./assets/contact/icon3.png": 34361,
	"./assets/contact/icon4.png": 93209,
	"./assets/contact/icon5.png": 97135,
	"./assets/contact/icon6.png": 92020,
	"./assets/contact/icon7.png": 13149,
	"./assets/contact/icon8.png": 86026,
	"./assets/contact/phone.png": 40543,
	"./assets/contact/wx.png": 98918,
	"./assets/contact/x.png": 72275,
	"./assets/cuisine/Asian/Asian1.png": 13931,
	"./assets/cuisine/Asian/Asian2.png": 112,
	"./assets/cuisine/Asian/Asian3.png": 6361,
	"./assets/cuisine/Burgers/burgers1.png": 73899,
	"./assets/cuisine/Burgers/burgers2.png": 60080,
	"./assets/cuisine/Burgers/burgers3.png": 66329,
	"./assets/cuisine/Chinese/Chinese1.png": 93591,
	"./assets/cuisine/Chinese/Chinese2.png": 4860,
	"./assets/cuisine/Chinese/Chinese3.png": 22373,
	"./assets/cuisine/Indian/img1.png": 51623,
	"./assets/cuisine/Indian/img2.png": 31564,
	"./assets/cuisine/Indian/img3.png": 661,
	"./assets/cuisine/Japanese/Japanese1.png": 5695,
	"./assets/cuisine/Japanese/Japanese2.png": 20420,
	"./assets/cuisine/Japanese/Japanese3.png": 83661,
	"./assets/cuisine/Kebabs/Kebabs1.png": 54773,
	"./assets/cuisine/Kebabs/Kebabs2.png": 34398,
	"./assets/cuisine/Korean/Korean1.png": 60017,
	"./assets/cuisine/Korean/Korean2.png": 83770,
	"./assets/cuisine/Korean/Korean3.png": 89955,
	"./assets/cuisine/Pizza/Pizza1.png": 33855,
	"./assets/cuisine/Pizza/Pizza2.png": 48580,
	"./assets/cuisine/Pizza/Pizza3.png": 11821,
	"./assets/cuisine/Thai/Thai1.png": 18785,
	"./assets/cuisine/Thai/Thai2.png": 69802,
	"./assets/cuisine/Thai/Thai3.png": 20563,
	"./assets/cuisine/cuisine_bg_1.png": 93625,
	"./assets/cuisine/cuisine_bg_2.png": 79618,
	"./assets/cuisine/cuisine_bg_3.png": 43275,
	"./assets/cuisine/cuisine_bg_4.png": 51284,
	"./assets/cuisine/cuisine_desc_demo.png": 90473,
	"./assets/flag/Flag_of_Portugal.png": 99584,
	"./assets/flag/Romania.png": 93738,
	"./assets/flag/Sweden.png": 31747,
	"./assets/flag/a-Austriaaodiliguoqi.png": 21587,
	"./assets/flag/a-Belgiumbilishiguoqi.png": 22655,
	"./assets/flag/a-Danmarkdanmaiguoqi.png": 19818,
	"./assets/flag/a-Finlandfenlanguoqi.png": 60236,
	"./assets/flag/a-Greekxilaguoqi.png": 67488,
	"./assets/flag/a-Holandhelanguoqi.png": 24778,
	"./assets/flag/a-Irelandaierlanguoqi.png": 31593,
	"./assets/flag/a-Italyyidaliguoqi.png": 76361,
	"./assets/flag/a-Norwaynuoweiguoqi.png": 47779,
	"./assets/flag/a-Swedenruidianguoqi.png": 52400,
	"./assets/flag/america.png": 2715,
	"./assets/flag/aodaliya.png": 217,
	"./assets/flag/bingdao.png": 29529,
	"./assets/flag/canada.png": 55841,
	"./assets/flag/china.png": 73726,
	"./assets/flag/deguoguoqi.png": 22662,
	"./assets/flag/france.png": 93478,
	"./assets/flag/hungary.png": 73721,
	"./assets/flag/maerta.png": 75909,
	"./assets/flag/poland.png": 64312,
	"./assets/flag/ruishi.png": 90845,
	"./assets/flag/saipulusi.png": 26906,
	"./assets/flag/siluofake.png": 37008,
	"./assets/flag/siluowenniya.png": 1160,
	"./assets/flag/uk.png": 63459,
	"./assets/flag/xibanyaguoqi.png": 98324,
	"./assets/icon/book_icon.png": 56647,
	"./assets/icon/facebook.png": 87540,
	"./assets/icon/facebook.svg": 72852,
	"./assets/icon/google.png": 20149,
	"./assets/icon/heart.png": 57214,
	"./assets/icon/heart_fill.png": 23584,
	"./assets/icon/icon_card.png": 16834,
	"./assets/icon/icon_cash.png": 35865,
	"./assets/icon/icon_fb.png": 13708,
	"./assets/icon/icon_ins.png": 8426,
	"./assets/icon/icon_paypal.png": 88701,
	"./assets/icon/icon_rights.png": 41737,
	"./assets/icon/icon_stripe.png": 82363,
	"./assets/icon/icon_tw.png": 27771,
	"./assets/icon/icon_viva.png": 49684,
	"./assets/icon/input_search.png": 32423,
	"./assets/icon/insta.svg": 50241,
	"./assets/icon/linkedin.png": 19434,
	"./assets/icon/linkedin.svg": 96718,
	"./assets/icon/sumb_down.png": 1482,
	"./assets/icon/sumb_up.png": 60565,
	"./assets/icon/telegram.png": 73173,
	"./assets/icon/tiktok.svg": 15590,
	"./assets/icon/twitter.svg": 55813,
	"./assets/icon/whiteHeart.png": 44657,
	"./assets/icon/x.png": 91522,
	"./assets/icon/youyube.svg": 34060,
	"./assets/iconfont/iconfont": 74752,
	"./assets/iconfont/iconfont.css": 24714,
	"./assets/iconfont/iconfont.js": 74752,
	"./assets/iconfont/iconfont.json": 92930,
	"./assets/iconfont/iconfont.ttf": 12002,
	"./assets/iconfont/iconfont.woff": 69394,
	"./assets/iconfont/iconfont.woff2": 81172,
	"./assets/images/cuiseNot.png": 46815,
	"./assets/images/discount.png": 75058,
	"./assets/images/download_modal_bg.png": 33527,
	"./assets/images/food.png": 23871,
	"./assets/images/google_download.png": 28211,
	"./assets/images/img_home.png": 3286,
	"./assets/images/ios_download.png": 92281,
	"./assets/images/live_chat.png": 93696,
	"./assets/images/location.png": 64318,
	"./assets/images/login_bg.png": 66392,
	"./assets/images/menu-cuise.png": 50284,
	"./assets/images/mobile_banner.png": 41256,
	"./assets/images/notfoundBg.png": 63335,
	"./assets/images/order_tips_download.jpg": 92559,
	"./assets/images/profile_default.png": 13074,
	"./assets/images/quotation.png": 13005,
	"./assets/images/right.png": 48349,
	"./assets/images/search.png": 34319,
	"./assets/images/skiLogo.png": 78493,
	"./assets/images/special.png": 84706,
	"./assets/index/app_download_bg.png": 59461,
	"./assets/index/download_index_mobile.png": 6809,
	"./assets/index/icon_index_1.png": 89409,
	"./assets/index/icon_index_2.png": 40426,
	"./assets/index/icon_index_3.png": 91187,
	"./assets/index/icon_index_cate2.png": 66385,
	"./assets/index/icon_index_cate3.png": 68520,
	"./assets/index/index_card.png": 47874,
	"./assets/logo-merchant.png": 6400,
	"./assets/logo.png": 33153,
	"./assets/menu/Shop_light.png": 4583,
	"./assets/menu/empty_cart.png": 16718,
	"./assets/menu/empty_cart2.png": 41406,
	"./assets/menu/empty_cart3.png": 12743,
	"./assets/menu/fhrs_0_en-gb.jpg": 11920,
	"./assets/menu/fhrs_1_en-gb.jpg": 32609,
	"./assets/menu/fhrs_2_en-gb.jpg": 1442,
	"./assets/menu/fhrs_3_en-gb.jpg": 79859,
	"./assets/menu/fhrs_4_en-gb.jpg": 7740,
	"./assets/menu/fhrs_5_en-gb.jpg": 43485,
	"./assets/menu/fhrs_AI_en-gb.jpg": 12196,
	"./assets/menu/fhrs_IR_en-gb.jpg": 25463,
	"./assets/menu/fhrs_P_en-gb.jpg": 71184,
	"./assets/menu/fhrs_pass_en-gb.jpg": 90241,
	"./assets/menu/menu_bg_1.png": 33565,
	"./assets/menu/menu_bg_2.png": 66150,
	"./assets/menu/menu_bg_3.png": 34895,
	"./assets/menu/modal_delivery.png": 16896,
	"./assets/menu/modal_dinein.png": 61075,
	"./assets/menu/modal_pickup.png": 58160,
	"./assets/merchant_pageloading.gif": 58409,
	"./assets/page_loading.gif": 83975,
	"./assets/points/award.png": 11263,
	"./assets/points/point.png": 62742,
	"./assets/policy/faqs_bg.png": 95320,
	"./components/BrowseComps/AddressSearchInput": 42550,
	"./components/BrowseComps/AddressSearchInput.vue": 42550,
	"./components/BrowseComps/BrowseMerchantBox": 74208,
	"./components/BrowseComps/BrowseMerchantBox.vue": 74208,
	"./components/BrowseComps/BrowseSortBox": 98426,
	"./components/BrowseComps/BrowseSortBox.vue": 98426,
	"./components/BrowseComps/ChooseAddressModal": 45501,
	"./components/BrowseComps/ChooseAddressModal.vue": 45501,
	"./components/BrowseComps/TagBar": 93026,
	"./components/BrowseComps/TagBar.vue": 93026,
	"./components/CheckoutComps/AddressBox": 56203,
	"./components/CheckoutComps/AddressBox.vue": 56203,
	"./components/CheckoutComps/CheckLoginBlock": 52355,
	"./components/CheckoutComps/CheckLoginBlock.vue": 52355,
	"./components/CheckoutComps/CheckoutCartBox": 54820,
	"./components/CheckoutComps/CheckoutCartBox.vue": 54820,
	"./components/CheckoutComps/DateTimePicker": 27036,
	"./components/CheckoutComps/DateTimePicker.vue": 27036,
	"./components/CheckoutComps/PaymentBox": 36613,
	"./components/CheckoutComps/PaymentBox.vue": 36613,
	"./components/CooikeDiv": 63023,
	"./components/CooikeDiv.vue": 63023,
	"./components/CustomerService": 60240,
	"./components/CustomerService.vue": 60240,
	"./components/DownloadAppModal": 40760,
	"./components/DownloadAppModal.vue": 40760,
	"./components/Footer": 52425,
	"./components/Footer.vue": 52425,
	"./components/Header": 97225,
	"./components/Header.vue": 97225,
	"./components/IndexComps/CategoryIndex": 51105,
	"./components/IndexComps/CategoryIndex.vue": 51105,
	"./components/IndexComps/DownloadBox": 47575,
	"./components/IndexComps/DownloadBox.vue": 47575,
	"./components/IndexComps/FaqsBox": 10234,
	"./components/IndexComps/FaqsBox.vue": 10234,
	"./components/IndexComps/MerchantBox": 98063,
	"./components/IndexComps/MerchantBox.vue": 98063,
	"./components/JudgeScreenMask": 80870,
	"./components/JudgeScreenMask.vue": 80870,
	"./components/LoadErrorModal": 11333,
	"./components/LoadErrorModal.vue": 11333,
	"./components/MenuComps/CartBox": 52863,
	"./components/MenuComps/CartBox.vue": 52863,
	"./components/MenuComps/CategoryBox": 82467,
	"./components/MenuComps/CategoryBox.vue": 82467,
	"./components/MenuComps/MenuBox": 5571,
	"./components/MenuComps/MenuBox.vue": 5571,
	"./components/MenuComps/MerchantOffMobile": 75477,
	"./components/MenuComps/MerchantOffMobile.vue": 75477,
	"./components/MerchantItem": 91011,
	"./components/MerchantItem.vue": 91011,
	"./components/MyComps/Account": 89524,
	"./components/MyComps/Account.vue": 89524,
	"./components/MyComps/Address": 16801,
	"./components/MyComps/Address.vue": 16801,
	"./components/MyComps/Booking": 6835,
	"./components/MyComps/Booking.vue": 6835,
	"./components/MyComps/Favorite": 8896,
	"./components/MyComps/Favorite.vue": 8896,
	"./components/MyComps/Orders": 10050,
	"./components/MyComps/Orders.vue": 10050,
	"./components/MyComps/Points": 6693,
	"./components/MyComps/Points.vue": 6693,
	"./components/PageLoading": 12322,
	"./components/PageLoading.vue": 12322,
	"./components/PhoneBtn": 50944,
	"./components/PhoneBtn.vue": 50944,
	"./components/Verifition/Verify": 21960,
	"./components/Verifition/Verify.vue": 21960,
	"./components/Verifition/Verify/VerifyPoints": 62048,
	"./components/Verifition/Verify/VerifyPoints.vue": 62048,
	"./components/Verifition/Verify/VerifySlide": 85315,
	"./components/Verifition/Verify/VerifySlide.vue": 85315,
	"./components/Verifition/api": 52925,
	"./components/Verifition/api/": 52925,
	"./components/Verifition/api/index": 52925,
	"./components/Verifition/api/index.js": 52925,
	"./components/Verifition/utils/ase": 49159,
	"./components/Verifition/utils/ase.js": 49159,
	"./components/Verifition/utils/util": 15162,
	"./components/Verifition/utils/util.js": 15162,
	"./config": 34642,
	"./config/": 34642,
	"./config/index": 34642,
	"./config/index.js": 34642,
	"./main": 51406,
	"./main.js": 51406,
	"./mixins/judgeScreenH5": 47258,
	"./mixins/judgeScreenH5.js": 47258,
	"./request": 63793,
	"./request/": 63793,
	"./request/index": 63793,
	"./request/index.js": 63793,
	"./router": 39325,
	"./router/": 39325,
	"./router/index": 39325,
	"./router/index.js": 39325,
	"./utils/app": 1558,
	"./utils/app.js": 1558,
	"./utils/bus": 13751,
	"./utils/bus.js": 13751,
	"./utils/debounce": 49098,
	"./utils/debounce.js": 49098,
	"./utils/getPickTimeList": 98057,
	"./utils/getPickTimeList.js": 98057,
	"./utils/jsencrypt": 61317,
	"./utils/jsencrypt.js": 61317,
	"./utils/judgeUseGoogle": 98396,
	"./utils/judgeUseGoogle.js": 98396,
	"./utils/manageCart": 34676,
	"./utils/manageCart.js": 34676,
	"./utils/payment": 7091,
	"./utils/payment.js": 7091,
	"./views": 74472,
	"./views/": 74472,
	"./views/404": 55242,
	"./views/404.vue": 55242,
	"./views/about": 74556,
	"./views/about/": 74556,
	"./views/about/components/BoxFive": 18392,
	"./views/about/components/BoxFive.vue": 18392,
	"./views/about/components/BoxFour": 96353,
	"./views/about/components/BoxFour.vue": 96353,
	"./views/about/components/BoxOne": 39650,
	"./views/about/components/BoxOne.vue": 39650,
	"./views/about/components/BoxSix": 79705,
	"./views/about/components/BoxSix.vue": 79705,
	"./views/about/components/BoxThree": 62467,
	"./views/about/components/BoxThree.vue": 62467,
	"./views/about/components/BoxTwo": 21048,
	"./views/about/components/BoxTwo.vue": 21048,
	"./views/about/index": 74556,
	"./views/about/index.vue": 74556,
	"./views/browse/browse": 74827,
	"./views/browse/browse.vue": 74827,
	"./views/category": 95485,
	"./views/category/": 95485,
	"./views/category/foodInfo": 34127,
	"./views/category/foodInfo.js": 34127,
	"./views/category/index": 95485,
	"./views/category/index.vue": 95485,
	"./views/checkout": 32925,
	"./views/checkout.vue": 32925,
	"./views/contact": 70782,
	"./views/contact/": 70782,
	"./views/contact/index": 70782,
	"./views/contact/index.vue": 70782,
	"./views/develop": 25351,
	"./views/develop/": 25351,
	"./views/develop/index": 25351,
	"./views/develop/index.vue": 25351,
	"./views/index": 74472,
	"./views/index.vue": 74472,
	"./views/login": 27883,
	"./views/login.vue": 27883,
	"./views/menu": 20620,
	"./views/menu.vue": 20620,
	"./views/my/editAddress": 14443,
	"./views/my/editAddress.vue": 14443,
	"./views/my/my": 87731,
	"./views/my/my.vue": 87731,
	"./views/my/mySecond": 14468,
	"./views/my/mySecond.vue": 14468,
	"./views/payment/appPayCenter": 41092,
	"./views/payment/appPayCenter.vue": 41092,
	"./views/payment/guavaPay": 91627,
	"./views/payment/guavaPay.vue": 91627,
	"./views/payment/orderSuccess": 36992,
	"./views/payment/orderSuccess.vue": 36992,
	"./views/payment/payFail": 53932,
	"./views/payment/payFail.vue": 53932,
	"./views/payment/paypal": 81476,
	"./views/payment/paypal.vue": 81476,
	"./views/payment/paypalAdvance": 1064,
	"./views/payment/paypalAdvance.vue": 1064,
	"./views/payment/stripe": 30908,
	"./views/payment/stripe.vue": 30908,
	"./views/payment/trustPayment": 86180,
	"./views/payment/trustPayment.vue": 86180,
	"./views/payment/trustPaymentJs": 81405,
	"./views/payment/trustPaymentJs.vue": 81405,
	"./views/payment/vivaWallet": 58665,
	"./views/payment/vivaWallet.vue": 58665,
	"./views/policy/cookiePolicy": 82465,
	"./views/policy/cookiePolicy.vue": 82465,
	"./views/policy/faqs": 8755,
	"./views/policy/faqs.vue": 8755,
	"./views/policy/private": 8856,
	"./views/policy/private.vue": 8856,
	"./views/policy/refundAndCancellations": 7663,
	"./views/policy/refundAndCancellations.vue": 7663,
	"./views/policy/termsAndConditions": 67581,
	"./views/policy/termsAndConditions.vue": 67581,
	"./views/review": 61739,
	"./views/review.vue": 61739
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25538;